/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
    const video = document.querySelector(".video-article-video video");;
    const playPauseButton = document.getElementById('play-pause-button');
    const playCircle = document.getElementById('play-circle');
    const playIcon = document.getElementById('play-icon');
    const pauseIcon1 = document.getElementById('pause-icon-1');
    const pauseIcon2 = document.getElementById('pause-icon-2');
    const thumbnail = document.getElementById('thumbnail');

    playPauseButton.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playCircle.style.display = 'none';
        playIcon.style.display = 'none';
        pauseIcon1.style.display = 'block';
        pauseIcon2.style.display = 'block';
        thumbnail.style.display = 'none';
      } else {
        video.pause();
        playCircle.style.display = 'block';
        playIcon.style.display = 'none';
        pauseIcon1.style.display = 'block';
        pauseIcon2.style.display = 'block';
        thumbnail.style.display = 'block';
      }
    });
  });
  $(document).ready(function () {
    const video = document.getElementById('video');
    const playPauseButton = document.getElementById('play-pause-button');
    const playButton = document.getElementById('play-button');
    const pauseButton = document.getElementById('pause-button');
    const thumbnail = document.getElementById('thumbnail');

    playPauseButton.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playButton.style.display = 'none';
        pauseButton.style.display = 'block';
        thumbnail.style.display = 'none';
      } else {
        video.pause();
        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
        thumbnail.style.display = 'block';
      }
    });

    if(video != null){
      video.addEventListener('ended', function () {
        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
        thumbnail.style.display = 'block';
      });
    }

 
  });
  $(document).ready(function () {
    var listContainer = $('.footer-location-list ul');
    var showMoreBtn = $('#show-more-btn');
    $(window).resize(function() {
      var width = $(window).width();

      if( width >= 768 ) {
    // Hide items beyond the initial four
    var itemlist = listContainer.find('li:gt(3)').addClass('hidden');

    // Show the "Show More" button if there are more than four items
    if (listContainer.find('li').length > 4) {
      showMoreBtn.show();
    }
    $('.footer-location-list ul li a').on('click', function(e){
      e.preventDefault();
    });
    showMoreBtn.on('click', function() {
      itemlist.slideToggle();
      $(this).toggleClass('hidden');
      var buttonText = showMoreBtn.hasClass('hidden') ? 'Show Less' : 'Show More';
      $(this).text(buttonText);

    });

  }else{
    var itemlist2 = listContainer.find('li:gt(3)').removeClass('hidden');
    showMoreBtn.hide();
    itemlist2.slideDown();
  }

  });


  $(window).resize();

  });
